<template>
    <div class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
        <div class="m-portlet__body m--padding-bottom-25">
            <div class="form-group m-form__group row">
                <div class="col-md-6">
                    <label for="firstName">First Name</label>
                    <input type="text" id="firstName" name="firstName" class="form-control m-input" v-model="user.firstName" data-vv-as="first name" v-validate="'required'">
                    <small v-show="errors.has('firstName')" class="m--font-danger">{{ errors.first('firstName') }}</small>
                </div>
                <div class="col-md-6">
                    <label for="lastName">Last Name</label>
                    <input type="lastName" id="lastName" name="lastName" class="form-control m-input" v-validate="'required'" data-vv-as="last name" v-model="user.lastName">
                    <small v-show="errors.has('lastName')" class="m--font-danger">{{ errors.first('lastName') }}</small>
                </div>
            </div>
            <div class="form-group m-form__group row">
                <div class="col-md-6">
                    <label for="phoneNo">Phone Number</label>
                    <input type="text" id="phoneNo" name="phoneNo" class="form-control m-input" v-model="user.phoneNo" data-vv-as="phone number" v-validate="'required'">
                    <small v-show="errors.has('phoneNo')" class="m--font-danger">{{ errors.first('phoneNo') }}</small>
                </div>
                <div class="col-md-6">
                    <label for="email">Email</label>
                    <input type="email" id="email" name="email" class="form-control m-input" v-validate="'required|email'" v-model="user.email">
                    <small v-show="errors.has('email')" class="m--font-danger">{{ errors.first('email') }}</small>
                </div>
            </div>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
                <div class="row">
                    <div class="col-lg-12">
                        <button type="save" class="btn btn-success pull-right" :class="{'m-loader m-loader--light m-loader--right':loading}" @click="updateProfile">
                            <i class="fa fa-save"></i> Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from "../../../../api";
import helpers from "../../../../helpers";

export default {
  name: "profile-details",
  data() {
    return {
      loading: false,
      user: {
        firstName: "",
        lastName: "",
        phoneNo: "",
        email: "",
        idNo: ""
      }
    };
  },
  methods: {
    updateProfile() {
      this.$validator.validateAll().then(valid => {
        this.toggleLoading();
        if (valid) {
          let txType = "update-profile";
          api
            .request(txType, this.user)
            .then(response => {
              this.toggleLoading();
              if (response.data.status == "00") {
                helpers.successAlert("Profile updated successfully", "Success");
              } else {
                helpers.errorAlert(response.data.message, "Error");
              }
            })
            .catch(error => {
              this.toggleLoading();
              helpers.errorAlert(
                "Connection to server failed. Please try later."
              );
            });
        }
      });
    },
    toggleLoading() {
      this.loading = this.loading ? false : true;
    }
  },
  mounted: function() {
    this.user = this.$store.state.user;
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/profile/partials/Details.vue